module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.complete) ? _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "150px",
      "label-position": "center"
    }
  }, [_c('div', _vm._l((_vm.fieldData), function(array, $index) {
    return (array[0].default.show) ? _c('el-row', {
      staticClass: "bg-wh bor-gray p-b-10 m-t-20",
      class: {
        'groupNameHidden': !array[0].default.group
      }
    }, [($index == 0 && !array[0].default.group) ? _c('div', {
      staticClass: "p-t-40"
    }) : _vm._e(), _vm._v(" "), (array[0].default.group) ? _c('h5', {
      staticClass: "form-group-name"
    }, [_vm._v(_vm._s(array[0].default.group))]) : _vm._e(), _vm._v(" "), _vm._l((array), function(item, index) {
      return (!_vm.isHidden(item)) ? _c('div', {
        staticClass: "p-l-20 p-r-20"
      }, [_c('el-col', {
        staticStyle: {
          "min-height": "80px"
        },
        attrs: {
          "span": _vm.getCol(item.default.layout)
        }
      }, [_c('div', [(item.default.type != _vm.TYPE_SUBFORM && !_vm.isHidden(item)) ? _c('el-form-item', {
        attrs: {
          "label": item.default.title,
          "prop": item.default.name
        }
      }, [(item.default.type == _vm.TYPE_INPUTTEXT) ? _c('honray-input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "rules": _vm.rules,
          "name": item.default.name,
          "type": item.input.write_type,
          "defaultValue": item.input.write_default,
          "minLength": item.input.write_min,
          "maxLength": item.input.write_max,
          "disabled": _vm.isReadonly(item),
          "decimal": item.input.decimal,
          "isNeed": item.default.is_needed === 1,
          "isUnique": item.input.is_unique == 1,
          "modelId": _vm.modelId,
          "fieldId": item.default.field_id
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_PASSWORD) ? _c('honray-password', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "rules": _vm.rules,
          "name": item.default.name,
          "encryptType": item.password.encrypt_type,
          "encryptSplit": item.password.encrypt_split,
          "minLength": item.password.write_min,
          "maxLength": item.password.write_max,
          "disabled": _vm.isReadonly(item),
          "isNeed": item.default.is_needed === 1
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_TEXTAREA) ? _c('honray-textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "rules": _vm.rules,
          "name": item.default.name,
          "defaultValue": item.textarea.write_default,
          "minLength": item.textarea.write_min,
          "maxLength": item.textarea.write_max,
          "disabled": _vm.isReadonly(item),
          "isNeed": item.default.is_needed === 1
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_RADIO) ? _c('honray-radio', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "rules": _vm.rules,
          "name": item.default.name,
          "options": item.options,
          "disabled": _vm.isReadonly(item)
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_CHECKBOX) ? _c('honray-checkbox', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "rules": _vm.rules,
          "name": item.default.name,
          "selectMin": item.checkbox.select_min,
          "selectMax": item.checkbox.select_max,
          "options": item.options,
          "disabled": _vm.isReadonly(item),
          "isNeed": item.default.is_needed === 1
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_SELECT) ? _c('honray-select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "rules": _vm.rules,
          "name": item.default.name,
          "options": item.options,
          "disabled": _vm.isReadonly(item)
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_STRUCT) ? _c('honray-struct', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "selectType": item.struct.select_type,
          "range": item.struct.select_range,
          "rules": _vm.rules,
          "default": item.struct.select_default,
          "name": item.default.name,
          "options": item.options,
          "disabled": _vm.isReadonly(item)
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_PERSON) ? _c('honray-people', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "selectType": item.people.select_type,
          "range": item.people.select_range,
          "rules": _vm.rules,
          "default": item.people.select_default,
          "options": item.options,
          "disabled": _vm.isReadonly(item)
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_USER) ? _c('honray-user', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "disabled": _vm.isReadonly(item),
          "isNeed": item.default.is_needed === 1,
          "user": item.user_info
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_DATE) ? _c('honray-date', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "rules": _vm.rules,
          "name": item.default.name,
          "type": item.date.type,
          "config": item.date,
          "isRange": item.date.range_status == 1,
          "placeholder": "选择日期",
          "disabled": _vm.isReadonly(item)
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_TIME) ? _c('honray-time', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "rules": _vm.rules,
          "name": item.default.name,
          "type": item.time.select_type,
          "config": item.time,
          "isRange": item.time.range_status == 1,
          "placeholder": "选择时间",
          "disabled": _vm.isReadonly(item)
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_BOTH_DATE_TIME) ? _c('honray-datetime', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "rules": _vm.rules,
          "name": item.default.name,
          "config": item.datetime,
          "isRange": item.datetime.range_status == 1,
          "placeholder": "选择日期时间",
          "disabled": _vm.isReadonly(item)
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_FILE) ? _c('honray-upload', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "title": item.default.title,
          "name": item.default.name,
          "config": item.file,
          "uploadUrl": _vm.host + 'form/upload/' + item.default.field_id,
          "disabled": _vm.isReadonly(item)
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "uploading": _vm.uploading,
          "input": function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }
        }
      }, [_vm._v(">\n            ")]) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_PHOTO) ? _c('honray-upload-img', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "disabled": _vm.isReadonly(item),
          "id": item.default.field_id,
          "config": item.image,
          "uploadUrl": _vm.host + 'form/upload/' + item.default.field_id
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_EDITOR && !_vm.isReadonly(item)) ? _c('honray-editor', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        ref: item.default.name,
        refInFor: true,
        attrs: {
          "id": item.default.name,
          "col": item.default.layout,
          "width": 650,
          "height": 200,
          "uploadImgUrl": item.uploadImgUrl,
          "hideLinkImg": item.hideLinkImg,
          "codeDefaultLang": item.editor.pc_code_type,
          "mapKey": item.editor.pc_map_key,
          "fileMaxSize": item.editor.pc_file_max,
          "fileUnit": _vm.getUnitText(item.editor.pc_file_unit),
          "disabledMenus": item.disabledMenus,
          "usePlupload": false
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_EDITOR && _vm.isReadonly(item)) ? _c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.form[item.default.name])
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_CASCADER) ? _c('honray-cascader', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "id": item.default.field_id,
          "disabled": _vm.isReadonly(item),
          "type": item.link.type,
          "filterable": item.link.has_search == 1,
          "showAllLevels": item.link.result_show == _vm.CASCADER_SHOW_FULL,
          "areaLimit": item.link.area_limit == 1,
          "areaConfig": item.link.area_config
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }]
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_FOREIGNKEY) ? _c('honray-foreignkey', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "disabled": _vm.isReadonly(item),
          "id": item.default.field_id,
          "name": item.default.name,
          "filterable": item.key.has_search == 1,
          "isLink": item.key.is_link == 1,
          "linkField": item.key.link_pid,
          "efficientOptions": item.options,
          "majorField": item.default.key_major,
          "depentField": item.default.key_depent,
          "type": item.key.type,
          "keyItem": item,
          "keyFilter": item.default.key_filter,
          "keyCascade": item.default.key_cascade,
          "keyFillin": item.default.key_fillin,
          "extraFieldList": _vm.extraFieldList,
          "hasNull": item.key.has_null == 1
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": [function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }, function($event) {
            _vm.valueChange(item)
          }],
          "setEfficientOptions": _vm.setEfficientOptions,
          "setKeyOptions": _vm.setKeyOptions,
          "setKeyData": _vm.setKeyData
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_DEALTIME) ? _c('honray-dealtime', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "unit": item.deal_time.unit
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_MULTIRELATE) ? _c('honray-relate', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "disabled": _vm.isReadonly(item),
          "id": item.default.field_id,
          "name": item.default.name,
          "config": item.multi_link,
          "rules": _vm.rules,
          "api": 'multi_link',
          "is-need": item.default.is_needed
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_SUBRELATE) ? _c('honray-relate', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "disabled": _vm.isReadonly(item),
          "id": item.default.field_id,
          "name": item.default.name,
          "config": item.child,
          "rules": _vm.rules,
          "api": 'child',
          "is-need": item.default.is_needed
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_OBTAIN_CONTENT) ? _c('honray-interface', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "disabled": _vm.isReadonly(item),
          "id": item.default.field_id,
          "config": item.interface,
          "rules": _vm.rules
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "transferInfo": _vm.transferInfo,
          "input": function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.default.tips) ? _c('div', {
        staticClass: "form-tips"
      }, [_vm._v(_vm._s(item.default.tips))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_SUBFORM && !_vm.isHidden(item)) ? _c('div', [_c('honray-subform', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form[item.default.name]),
          expression: "form[item.default.name]"
        }],
        attrs: {
          "name": item.default.name,
          "title": item.default.title,
          "inputList": item.form.data,
          "dataLimit": item.form.write_num,
          "disabled": _vm.isReadonly(item),
          "rules": _vm.rules
        },
        domProps: {
          "value": (_vm.form[item.default.name])
        },
        on: {
          "input": function($event) {
            var $$exp = _vm.form,
              $$idx = item.default.name;
            if (!Array.isArray($$exp)) {
              _vm.form[item.default.name] = $event
            } else {
              $$exp.splice($$idx, 1, $event)
            }
          }
        }
      })]) : _vm._e()])]), _vm._v(" "), (item.default.type == _vm.TYPE_FOREIGNKEY) ? _vm._l((item.default.key_depent), function(depent) {
        return _c('el-col', {
          staticClass: "foreign m-h-80",
          attrs: {
            "span": _vm.getCol(item.default.layout)
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": depent.title
          }
        }, [(_vm.form[item.default.name] && _vm.keyData[item.default.name] && _vm.keyData[item.default.name][_vm.form[item.default.name]]) ? _c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.keyData[item.default.name][_vm.form[item.default.name]][depent.name]),
            expression: "keyData[item.default.name][form[item.default.name]][depent.name]"
          }],
          staticClass: "h-40 w-100p mw-300",
          attrs: {
            "disabled": ""
          },
          domProps: {
            "value": (_vm.keyData[item.default.name][_vm.form[item.default.name]][depent.name])
          },
          on: {
            "input": function($event) {
              var $$exp = _vm.keyData[item.default.name][_vm.form[item.default.name]],
                $$idx = depent.name;
              if (!Array.isArray($$exp)) {
                _vm.keyData[item.default.name][_vm.form[item.default.name]][depent.name] = $event
              } else {
                $$exp.splice($$idx, 1, $event)
              }
            }
          }
        }) : _c('el-input', {
          staticClass: "h-40 w-100p mw-300",
          attrs: {
            "disabled": ""
          }
        }), _vm._v(" ")])])
      }) : _vm._e()], true) : _vm._e()
    })], true) : _vm._e()
  })), _vm._v(" "), _vm._t("default")], true) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6afbf780!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/render/commonFormRender.vue
// module id = 1904
// module chunks = 2